import { FeatureTreeVo } from '@/service/swet/models';

export const formatTreeToValues = (
    nodes?: FeatureTreeVo[],
    parentId?: number | string,
    parentNames: string[] = [],
): any[] => {
    if (!nodes?.length) {
        return [];
    }
    return nodes.map((node) => {
        const pid = parentId ? `${parentId}_${node.id}` : node.id;
        const pNames = parentNames.concat(node.name);

        return Object.assign(
            {
                pNames,
                id: node.id,
                name: node.name,
                label: node.name,
                value: pid,
                selected: node.selected,
                recommend: node.recommend,
            },
            node.children.length
                ? { children: formatTreeToValues(node.children, pid, pNames) }
                : {},
        );
    });
};

export function getLeafValue(tree: { children?: any[] }[]) {
    const res = [];
    if (!tree || !tree?.length) {
        return [];
    }
    function deepPlus(tree: any[]) {
        tree.forEach((item) => {
            if (item?.children?.length) {
                deepPlus(item.children);
            } else {
                res.push(item);
            }
        });
    }
    deepPlus(tree);
    return res;
}
